import { AnnouncementArchiveEntitiesState } from './announcement-archive-entities.state';

export const announcementArchiveEntitiesStateInitial: AnnouncementArchiveEntitiesState = {
  announcements: [],
  totalElements: 0,
  currentPage: 0,
  pageSize: 12,
  imageUrls: {},
  isLoading: false,
  isLoaded: false,
  error: null,
};
